<template>
  <standard-layout header="Artikel bearbeiten">
    <template v-slot:main>
      <ArticleFilter :articles="articles" @filter="filteredArticles = $event"/>
      <ArticleList :articles="filteredArticles" @select="selectedArticles = $event" @update="loadArticles"/>
      <div class="row mt-3 border-top border-primary pt-2" v-if="selectedArticles.length > 0">
        <div class="col-12 h5">Aktion auf {{ selectedArticles.length }} anwenden</div>
        <div class="col">
          <button class="btn btn-warning" :disabled="selectedArticles.length === 0"
                  @click="generateArticleCopiesForNextYear">
            Kopien für kommendes Jahr erstellen
          </button>
        </div>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import ArticleFilter from "@/components/shop/ArticleFilter";
import ArticleList from "@/components/shop/ArticleList";

export default {
  components: {ArticleList, ArticleFilter, StandardLayout},
  data() {
    return {
      articles: [],
      filteredArticles: [],
      selectedArticles: []
    }
  },
  methods: {
    loadArticles() {
      this.$api.get(`/articles`, {
        params: {
          channel: 'WEB'
        }
      }).then(res => {
        this.articles = res.data
        this.filteredArticles = res.data
      }).catch(err => this.handleError(err))
    },
    generateArticleCopiesForNextYear() {
      this.$api.put(`/articles`, this.selectedArticles.map(a => a.id), {
        params: {
          action: 'copyForNextYear'
        }
      }).then(() => this.loadArticles())
          .catch(err => this.handleError(err))
    }
  },
  activated() {
    this.loadArticles()
  },
  mounted() {
    this.loadArticles()
  }
}
</script>
